import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import { randomStr } from '@/utils/sign';

// RSA 公钥（与后端保持一致，仅用于加密每次随机生成的 AES 密钥）
const RSA_PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtwiy2quTT31WWH1pZ3kpB+nAb6mui3uAhSEF5pYjl5TgMFhEz/phm/e59iVZsdBoOdCIiir/WY78j/6GlABBAOjyX6V7wFWeLTukFrWtRLcqVo1YYXvtucHFQ76ni6ASMaHs/7ka5V90tI+fhvyGZTuP9ghOJnLgnA1rJlZKoEbqg9OZBV7mH2kYerxHI9Q6hvTdrjwKAodOu18wlvZnGgD1XzXjWe//cShpvQjl1XY6PI8stz74KsUs090eksgf9rX6pLTjdkGTZUBONIRUvhYx2vg3sJBK9Btc9C3fARYVa6uy0VPHIFPHq+He4NZZbElzTBIqN0OacaE3vcrMtwIDAQAB';

// 请求体加密总开关（后端 crypto-enabled=true 时必须为 true，否则 JSON 请求会被拒绝）
export const ENABLE_CRYPTO = true;

/**
 * 请求体混合加密（纯函数）
 * AES-CBC/PKCS7 加密业务 JSON，密钥与 IV 均为每次请求随机生成的 16 位字符串；
 * AES 密钥用 RSA(PKCS1 v1.5) 公钥加密后随请求体一起下发。
 * @param {object} data 业务 JSON 对象（无参数时传 {}）
 * @returns {{ key: string, iv: string, data: string }} 密文体，三个字段均为 Base64 字符串
 */
export function encryptBody(data) {
    // 每次请求现场随机生成，禁止复用
    const aesKey = randomStr(16);
    const ivStr = randomStr(16);

    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(RSA_PUBLIC_KEY);

    // 必须使用 Utf8.parse 生成的 WordArray，直接传字符串会走口令派生模式导致后端无法解密
    const cipher = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(JSON.stringify(data)),
        CryptoJS.enc.Utf8.parse(aesKey),
        {
            iv: CryptoJS.enc.Utf8.parse(ivStr),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return {
        // RSA 公钥加密 aesKey 原文，jsencrypt 默认输出 Base64
        key: jsencrypt.encrypt(aesKey),
        // 明文 ivStr 的 UTF-8 字节做 Base64（不是加密结果）
        iv: CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(ivStr)),
        data: cipher.toString(),
    };
}
